import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { addYears } from 'date-fns';
import { DateInput } from 'src/components/enterprise/components/DateInput/DateInput';

export interface EffectiveDateControlProps {
  id: string;
  name: string;
}

export const EffectiveDateControl = ({
  id,
  name,
}: EffectiveDateControlProps): JSX.Element => {
  const { errors, control } = useFormContext();

  return (
    <DateInput
      id={id}
      name={name}
      label="Java Effective Date *"
      control={control}
      error={errors[name]}
      rules={{
        required: 'Effective Date is required',
      }}
      disabledDays={{
        before: addYears(new Date(), -1),
      }}
    />
  );
};
